<div *ngIf="toggled && isMobile" class="jmCollapseTitleLearnMore" style="background-color:#fff;">
	<div class="jmPageTitle" style="padding-top: 10px;">
		Regional Statistics
		<div class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square" role="button" (click)="toggleCollapse()"></div>
	</div>
</div>

<table id="tblRegionalStatistics" *ngIf="!toggled" class="w-100" style="margin:0px; padding:0px; overflow:auto;">
	<tbody>
		<tr>
			<td style="vertical-align:bottom;">
				<div class="p-2">
					<div class="jmPageTitle" style="display:inline-block;">Regional Statistics</div>
					<div *ngIf="!stateStatistics" #regionOption="ngbDropdown" ngbDropdown style="display:inline-block;">
						<div ngbDropdownToggle class="text-info" role="button" style="margin-left: 30px;">Change Location</div>
						<table ngbDropdownMenu style="min-width: 300px;">
							<tr>
								<td style="padding:5px;text-align:right;">Zip Code</td>
								<td style="padding:5px;"><input type="text" [(ngModel)]="formData.schoolZipCode" class="form-control input-xs" placeholder="Zip Code" style="width:150px;" size="5" maxlength="5" onclick="event.stopPropagation();" /></td>
								<td style="padding:5px;"><button class="btn btn-info" (click)="locationChange($event, 'zipcode')" [disabled]="displayZipCodeWarning">Apply</button></td>
							</tr>
							<tr *ngIf="displayZipCodeWarning"><td style="color:red; padding-left:20px;" colspan="3">Please enter a 5 digit number.</td></tr>
							<tr>
								<td style=" padding:5px; text-align:right;">Or State</td>
								<td style="padding:5px;">
									<select id="selChangeState" [(ngModel)]="formData.schoolState" class="form-select" style="width:150px;">
										<option *ngFor="let opt of allStates" [ngValue]="opt">{{opt.Name}}</option>
									</select>
								</td>
								<td style="padding:5px;"><button type="button" class="btn btn-info" (click)="locationChange($event, 'state')">Apply</button></td>
							</tr>
						</table>
					</div>
					<div (click)="toggleCollapse()" *ngIf="isMobile" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square"></div>
				</div>
			</td>
		</tr>

		<tr id="trLocalEconomy" *ngIf="includeCyberEconomy">
			<td>
				<div *ngIf="chartReady" class="jmWidgetPadding h-100" style="background-color:#fff;">
					<div class="jmPageTitle">San Diego's Cyber Economy</div>
					<div class="row text-center" style="margin-top: 20px;">
						<div class="col-md-4 col-12">
							<div *ngIf="isMobile" class="row">
								<div class="col-sm-2"> </div>
								<div class="col-sm-8 col-12">
									<img src="assets/images/cyber/TotalFirms.png" style="width:60%; height:auto;" />
								</div>
								<div class="col-sm-2"> </div>
							</div>
							<div *ngIf="!isMobile">
								<img src="assets/images/cyber/TotalFirms.png" style="width:60%; height:auto;" />
							</div>
						</div>
						<div class="col-md-4 col-12">
							<div *ngIf="isMobile" class="row">
								<div class="col-sm-2"> </div>
								<div class="col-sm-8 col-12">
									<img src="assets/images/cyber/TotalImpactJobs.png" style="width:60%; height:auto;" />
								</div>
								<div class="col-sm-2"> </div>
							</div>
							<div *ngIf="!isMobile">
								<img src="assets/images/cyber/TotalImpactJobs.png" style="width:60%; height:auto;" />
							</div>
						</div>
						<div class="col-md-4 col-12">
							<div *ngIf="isMobile" class="row">
								<div class="col-sm-2"> </div>
								<div class="col-sm-8 col-12">
									<img src="assets/images/cyber/TotalEconomicImpact.png" style="width:60%; height:auto;" />
								</div>
								<div class="col-sm-2"> </div>
							</div>
							<div *ngIf="!isMobile">
								<img src="assets/images/cyber/TotalEconomicImpact.png" style="width:60%; height:auto;" />
							</div>
						</div>
					</div>
				</div>
			</td>
		</tr>
		<tr *ngIf="includeCyberEconomy && !isMobile"><td style="height:10px;"></td></tr>

		<tr id="trChart0">
			<td>
				<div class="row h-100">
					<div class="col-md-6 col-12 h-100" [ngStyle]="(isMobile)?{'margin-top':'10px'}:{}">
						<app-bls-report *ngIf="chartReady" reportType="UnemploymentRate" [zipCode]="zipCode" [state]="state"></app-bls-report>
					</div>
					<div class="col-md-6 col-12 h-100" [ngStyle]="(isMobile)?{'margin-top':'10px'}:{}">
						<app-bls-report *ngIf="chartReady" reportType="Employment" [zipCode]="zipCode" [includeNational]="falseValue" [state]="state"></app-bls-report>
					</div>
				</div>
			</td>
		</tr>
		<tr *ngIf="!isMobile"><td style="height:10px;"></td></tr>
		<tr id="trChart1">
			<td>
				<div class="row h-100">
					<div class="col-md-6 col-12 h-100" [ngStyle]="(isMobile)?{'margin-top':'10px'}:{}">
						<app-bls-report *ngIf="chartReady" reportType="WeeklyWage" [zipCode]="zipCode" [state]="state"></app-bls-report>
					</div>
					<div class="col-md-6 col-12 h-100" [ngStyle]="(isMobile)?{'margin-top':'10px'}:{}">
						<app-bls-report *ngIf="chartReady" reportType="Establishment" [zipCode]="zipCode" [includeNational]="falseValue" [state]="state"></app-bls-report>
					</div>
				</div>
			</td>
		</tr>
	</tbody>
</table>
